<template>
  <div id="page" class="container-fluid">
    <div class="row header mx-4 my-4">
      <div class="col my-3">
        <h1>Custom Notifications
        <b-button class="ml-3" variant="outline-orange" @click="addCustomNotification()">
          <font-awesome-icon class="orange" icon="plus"/>
          New
        </b-button></h1>
      </div>
  </div>
    <div class="container-fluid">
      <div class="row data-table-header">
        <div class="col-1">Order</div>
        <div class="col-2">Name</div>
        <div class="col-6">Template</div>
        <div class="col-3"></div>
      </div>
      <div v-for="customNotification in customNotifications" class="row custom-notification-row"  :key="customNotification.organizationCustomNotificationId">
        <div class="column col-1">{{ customNotification.order }}</div>
        <div class="column col-2">{{ customNotification.name }}</div>
        <div class="column col-6">{{ customNotification.template }}</div>
        <div class="col-3 text-right button-container">
          <button title="Edit" @click.prevent="editCustomNotification(customNotification)" type="button" class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'edit']"/>Edit
          </button>
          <button title="Delete" @click.prevent="deleteCustomNotification(customNotification.organizationCustomNotificationId)" type="button" class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'trash-alt']"/>Delete
          </button>
        </div>
      </div>
      </div>
    <custom-notification-modal :edit-custom-notification="editingCustomNotification" @updated="customNotificationUpdated" :visible="showingCustomNotificationModal"
                               @update:visible="visible => showingCustomNotificationModal = visible"></custom-notification-modal>
    </div>
</template>
<script>
  import api from '@/services/api'
  import CustomNotificationModal from '@/components/CustomNotificationModal.vue'

  export default {
    name: 'CustomNotifications',
    components: { CustomNotificationModal },

    data () {
      return {
        customNotifications: [],
        showingCustomNotificationModal: false,
        editingCustomNotification: {
          name: '',
          order: 0,
          template: ''
        }
      }
    },

    watch: {
      currentPage (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.loadData()
        }
      }
    },
    methods: {
      loadData () {
        this.errors = []
        this.isLoading = true
        api.get('Dashboard/Organization/CustomNotifications').then(response => {
          this.customNotifications = response.data
          this.isLoading = false
        })
      },
      customNotificationUpdated () {
        this.showingCustomNotificationModal = false
        this.loadData()
      },

      addCustomNotification () {
        if (this.customNotifications.length > 0) {
          this.editingCustomNotification = {
            order: this.customNotifications[this.customNotifications.length - 1].order + 1
          }
        } else {
          this.editingCustomNotification = {
            order: 0
          }
        }
        this.showingCustomNotificationModal = true
      },

      editCustomNotification (customNotification) {
        this.editingCustomNotification = customNotification
        this.showingCustomNotificationModal = true
      },

      deleteCustomNotification (customNotificationid) {
        api.delete('Admin/Organization/CustomNotifications/' + customNotificationid).then(() => {
          this.loadData()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.$log.error('Error attempting to delete custom notification: ' + error.message, error)
          }
        })
      }
    },
    created () {
      this.loadData()
    }
  }
</script>

<style scoped>

.custom-notification-row .column {
  padding: 0.75rem;
  vertical-align: bottom;
  border-collapse: collapse;
}

.custom-notification-row {
  border-bottom: 1px solid #dee2e6;
  background-color: #f9f9f9;
}
</style>
